// Countries used for previewing country-gated elabel widget content
// (e.g. Italian / Spanish recyclability sections in the Sustainability widget).
export default [
  { key: 'AT', description: 'Austria' },
  { key: 'BE', description: 'Belgium' },
  { key: 'BG', description: 'Bulgaria' },
  { key: 'HR', description: 'Croatia' },
  { key: 'CY', description: 'Cyprus' },
  { key: 'CZ', description: 'Czechia' },
  { key: 'DK', description: 'Denmark' },
  { key: 'EE', description: 'Estonia' },
  { key: 'FI', description: 'Finland' },
  { key: 'FR', description: 'France' },
  { key: 'DE', description: 'Germany' },
  { key: 'GR', description: 'Greece' },
  { key: 'HU', description: 'Hungary' },
  { key: 'IE', description: 'Ireland' },
  { key: 'IT', description: 'Italy' },
  { key: 'LV', description: 'Latvia' },
  { key: 'LT', description: 'Lithuania' },
  { key: 'LU', description: 'Luxembourg' },
  { key: 'MT', description: 'Malta' },
  { key: 'NL', description: 'Netherlands' },
  { key: 'NO', description: 'Norway' },
  { key: 'PL', description: 'Poland' },
  { key: 'PT', description: 'Portugal' },
  { key: 'RO', description: 'Romania' },
  { key: 'SK', description: 'Slovakia' },
  { key: 'SI', description: 'Slovenia' },
  { key: 'ES', description: 'Spain' },
  { key: 'SE', description: 'Sweden' }
]
